import React, { useEffect, useRef, useState } from "react";
// import {
//   InputField,
//   Modal,
//   TextComponent,
// } from "../../../../components";
import styles from "./addAssets.module.css";
import { Checkbox, List } from "antd";
import { PiSealCheck } from "react-icons/pi";
import { TbDeviceRemote } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import uploadPicture from "../../../../assets/images/uploadPicture.png";
import ModalComponent from "../../../../components/modal/ModalComponent";
import TextComponent from "../../../../components/textComponent/TextComponent";
import InputField from "../../../../components/input/InputField";
import { CusAssetsMiddleware } from "../../../../Store/Middlewares/CusAssetsMiddleware";
import { Dropdown } from "../../../../components";
import { PagesMiddleware } from "../../../../Store/Middlewares/PagesMiddleware";
const AddAssets = ({ isOpen, setIsOpen, from, setActiveTab }) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [name, setname] = useState("");
  const [make, setmake] = useState("");
  const [model, setmodel] = useState("");
  const [vinNo, setvinNo] = useState("");
  const [licenceNo, setlicenceNo] = useState("");
  const [deviceId, setdeviceId] = useState("");
  const [deviceName, setdeviceName] = useState("");
  const [stock, setstock] = useState("");
  const [year, setYear] = useState("");
  const [assetImage, setassetImage] = useState(null);
  const [batteryVolt, setbatteryVolt] = useState("");
  const [trim, setTrim] = useState("");
  const [color, setColor] = useState("");
  const [lot_no, setLot_no] = useState({ value: "", id: "" });

  const lot_numbers = useSelector((state) => state.PagesReducer?.lot_numbers);

  const imgRef = useRef();
  const onCreateAssets = () => {
    let userData = {
      name,
      make,
      model,
      vinNo,
      licenceNo,
      deviceId,
      deviceName,
      assetImage,
      batteryVolt,
      trim,
      color,
      stock,
      year,
      lot_no: lot_no?.id,
    };
    if (assetImage === null) delete userData.assetImage;
    if (
      // !name ||
      // !make ||
      // !model ||
      !vinNo
      // !stock
      // ||!assetImage
    ) {
      dispatch(
        showAlert({ type: "Error", message: "All fields are required" }),
      );
      // } else if (!deviceId) {

      //   dispatch(
      //     showAlert({
      //       title: "Error",
      //       message: "Please enter Module id given by merchant!",
      //     }),
      //   );
    } else if (batteryVolt > 12) {
      dispatch(
        showAlert({
          title: "Error",
          message: "Battery volt should be less than 12V",
        }),
      );
    } else {
      if (from == "customer") {
        dispatch(CusAssetsMiddleware.createCusAssets(userData))
          .then((data) => {
            setIsOpen(false);
            setassetImage(null);
            setdeviceId("");
            setdeviceName("");
            setlicenceNo("");
            setmake("");
            setmodel("");
            setname("");
            setvinNo("");
            setTrim("");
            setColor("");
            setstock("");
            setstock("");
            setYear("");
            setLot_no("");
          })
          .catch(() => {});
      } else {
        dispatch(AssetsMiddleware.createAssets(userData))
          .then((data) => {
            setIsOpen(false);
            setassetImage(null);
            setdeviceId("");
            setdeviceName("");
            setlicenceNo("");
            setmake("");
            setmodel("");
            setname("");
            setvinNo("");
            setTrim("");
            setColor("");
            setYear("");
            setstock("");
            setLot_no("");
          })
          .catch(() => {});
      }
    }
  };

  const getData = (name) => {
    dispatch(
      PagesMiddleware.lotnumber({
        params: { name },
        route: "",
        method: "get",
      }),
    );
  };

  useEffect(() => {
    getData("");
  }, []);

  return (
    <>
      <ModalComponent
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        width={"800px"}
        twoButton
        okBtnTitle={"Save Information"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setIsOpen(false);
        }}
        onClickOkButton={
          onCreateAssets
          // ()=>{setIsOpen(false); setSuccess(true)}
        }
        btnStyle={{ width: "80%" }}
        // headingClass={styles.modalHeading}
      >
        <div className={styles.mainCont}>
          <TextComponent
            text={"Setup Vehicle Information"}
            className={styles.heading}
          />
          <TextComponent
            text={"Please provide detailed information about your vehicle."}
            // className={styles.heading}
          />
          <div className={styles.formDivideDiv}>
            <div className={styles.formDivideInput}>
              <img
                className={styles.slectImg}
                onClick={() => imgRef.current.click()}
                src={
                  assetImage ? URL.createObjectURL(assetImage) : uploadPicture
                }
                alt=""
              />
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={imgRef}
                onChange={(e) => setassetImage(e.target.files[0])}
              />
            </div>
            <div className={styles.formDivideInput}>
              <InputField
                label={"Name"}
                placeholder={"Write here"}
                value={name}
                onChange={(e) => setname(e.target.value)}
              />
              <InputField
                label={"Make"}
                placeholder={"Write here"}
                value={make}
                onChange={(e) => setmake(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.formDivideDiv}>
            <InputField
              label={"Model"}
              placeholder={"Write here"}
              value={model}
              className={styles.formDivideInput}
              onChange={(e) => setmodel(e.target.value)}
            />
            {/* <Dropdown
              className={styles.formDivideInput}
              label={"Lot Name"}
              value={lot_no}
              labelStyle={{ color: "#838383", fontSize: 18 }}
              style={{ color: "black" }}
              options={lot_numbers?.map((lot) => ({
                value: lot?.name,
                id: lot?.id,
              }))}
              onChange={(e) => setLot_no(e)}
            /> */}
          </div>

          <div className={styles.formDivideDiv}>
            <InputField
              // type="number"
              label={"VIN (Vehicle Identification Number)"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={vinNo}
              onChange={(e) => setvinNo(e.target.value)}
              maxLength={17}
            />
            <InputField
              label={"License Plate Number(Optional)"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={licenceNo}
              onChange={(e) => setlicenceNo(e.target.value)}
              maxLength={8}
            />
          </div>

          {/* <InputField
            type={"number"}
            label={"Vehicle Battery Voltage(Optional)"}
            placeholder={"Write here"}
            value={batteryVolt}
            onChange={(e) => setbatteryVolt(e.target.value)}
          /> */}
          <div className={styles.formDivideDiv}>
            <InputField
              label={"Trim"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={trim}
              onChange={(e) => setTrim(e.target.value)}
            />
            <InputField
              label={"Color"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
          <div className={styles.formDivideDiv}>
            <InputField
              label={"Device ID"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={deviceId}
              onChange={(e) => setdeviceId(e.target.value)}
            />
            <InputField
              label={"Stock"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={stock}
              onChange={(e) => setstock(e.target.value)}
              // type="number"
            />
          </div>
          <div className={styles.formDivideDiv}>
            {/* <InputField
              type={"number"}
              label={"Vehicle Battery Voltage(Optional)"}
              placeholder={"Write here"}
              value={batteryVolt}
              className={styles.formDivideInput}
              onChange={(e) => setbatteryVolt(e.target.value)}
            /> */}
            <InputField
              type={"number"}
              label={"Year"}
              placeholder={"Write here"}
              value={year}
              className={styles.formDivideInput}
              onChange={(e) => setYear(e.target.value)}
            />
          </div>
          {/* <InputField 
          label={"Location tag"}
          />
          <Dropdown
            className={styles.input}
            label={"Module"}
            placeholder={"Select module"}
            labelStyle={{ color: "#838383", fontSize: 18 }}
            style={{ color: "black" }}
            options={[
              {
                value: "Module 1",
                id: 1,
              },
              {
                value: "Module 2",
                id: 2,
              },
            ]}
            // onChange={(e) => setRole(e)}
          /> */}
          {/* <Checkbox className={styles.check} onChange={onChange}>
            Enable geofencing and location tracking for added security
          </Checkbox> */}
        </div>
      </ModalComponent>
      <ModalComponent
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Vehicle Added Successfully"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></ModalComponent>
    </>
  );
};

export default AddAssets;
